/**
 * adminConfig.js
 * Configurações centralizadas para administradores do sistema.
 */

// Lista de UIDs de administradores permitidos
export const ADMIN_UIDS = [
    'Vn5Q4zJeW2SoECy4xHZGPbgHFok1', // Admin Principal (Aécio)
    // Adicione outros UIDs aqui
];

/**
 * Verifica se um determinado UID pertence a um administrador.
 * @param {string} uid - UID do usuário do Firebase
 * @returns {boolean}
 */
export const isAdmin = (uid) => {
    if (!uid) return false;
    return ADMIN_UIDS.includes(uid);
};
